import { render } from "./LeadCard.vue?vue&type=template&id=2a480785&lang=pug"
import script from "./LeadCard.vue?vue&type=script&lang=js"
export * from "./LeadCard.vue?vue&type=script&lang=js"

import "./LeadCard.vue?vue&type=style&index=0&id=2a480785&lang=scss"

import exportComponent from "/var/www/valley_watch_firm/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__